angular.module('relayHealth').constant('org_constants', {
  RIDER_ORG_CLASS: 'rider',
  BUSINESS_ORG_CLASS: 'business',
});
